var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { message, Spin } from "antd";
import { pick } from "lodash";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerDetailsView } from "../core";
import TokenForm from "./components/TokenForm";
import { getAxios } from "../../../../backend";
import { API_PATH } from "../../../../constants";
const ApiTokensDetailsView = observer(({ entityId, operation, onCancel, onCompleted, }) => {
    const { agentsStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [tokens, setTokens] = useState([]);
    const [scopesInfo, setScopesInfo] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    useEffect(() => {
        setDataLoaded(false);
        loadData();
    }, [entityId]);
    const loadData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const axios = yield getAxios();
            const [tokensRes, scopesRes] = yield Promise.all([
                axios.get(API_PATH.API_TOKENS),
                axios.get(API_PATH.API_TOKENS + "/scopes"),
            ]);
            setTokens(tokensRes.data);
            setScopesInfo(scopesRes.data);
            setDataLoaded(true);
        }
        catch (error) {
            console.error("Failed to load data:", error);
            setDataLoaded(true);
        }
    });
    const entity = (() => {
        if (!entityId || operation === Operation.CREATE)
            return null;
        return tokens.find((t) => t._id === entityId) || null;
    })();
    if (entityId && operation !== Operation.CREATE && !dataLoaded) {
        return (React.createElement("div", { style: { display: "flex", justifyContent: "center", alignItems: "center", height: "200px" } },
            React.createElement(Spin, { size: "large" })));
    }
    const renderDeleteQuestion = (token) => {
        return React.createElement(Trans, { i18nKey: "sureDeleteName", values: { name: token.title } });
    };
    const handleSave = (formData, existingToken) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const tokenData = Object.assign(Object.assign({}, pick(formData, ["title", "scopes"])), (existingToken ? { token: existingToken.token } : {}));
            const axios = yield getAxios();
            yield axios.post(API_PATH.API_TOKENS, tokenData);
            if (existingToken) {
                message.success(React.createElement(Trans, { i18nKey: "tokenEditSuccess", values: { name: formData.title } }));
            }
            else {
                message.success(React.createElement(Trans, { i18nKey: "tokenCreateSuccess", values: { name: formData.title } }));
            }
            // Reload tokens
            const { data } = yield axios.get(API_PATH.API_TOKENS);
            setTokens(data);
        }
        catch (error) {
            console.error("Failed to save token:", error);
            message.error(React.createElement(Trans, { i18nKey: "tokenSaveError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    const handleDelete = (token) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const axios = yield getAxios();
            yield axios.post(API_PATH.API_TOKENS + "/delete", { token: token.token });
            message.success(React.createElement(Trans, { i18nKey: "tokenDeleteSuccess", values: { name: token.title } }));
            // Reload tokens
            const { data } = yield axios.get(API_PATH.API_TOKENS);
            setTokens(data);
        }
        catch (error) {
            console.error("Failed to delete token:", error);
            message.error(React.createElement(Trans, { i18nKey: "tokenDeleteError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    const canDelete = agentsStore.hasPermissions([Permissions.Permission.api_tokens_manage]);
    return (React.createElement(ManagerDetailsView, { entity: entity, entityId: entityId, operation: operation, form: TokenForm, formProps: {
            scopesInfo,
        }, loading: loading, renderDeleteQuestion: renderDeleteQuestion, onEntitySave: handleSave, onEntityDelete: canDelete ? handleDelete : undefined, onCancel: onCancel, onSaveCompleted: onCompleted, onDeleteCompleted: onCompleted }));
});
export default ApiTokensDetailsView;
